.table {
  width: 100%;
}

.tableHead {
  text-transform: uppercase;
  text-align: left;
  font-size: var(--font-size-s);
  color: #2a373d;

  th {
    padding: var(--space-s);
    border-bottom: 1px solid #e6e6e6;
    font-weight: var(--font-weight-bold);
  }
}

.tableBody {
  font-size: var(--font-size-s);

  tr {
    transition: background 0.15s ease-in-out;

    &:hover {
      background: #f8f8f8;
    }
  }

  td {
    padding: var(--space-s);
    vertical-align: middle;
  }
}

.tableHeader {
  margin-bottom: var(--space-xl);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.tableFilter {
  flex-basis: 30%;
  margin-right: var(--space-xl);
}
